import * as THREE from 'three'
import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { Instances, Instance, OrbitControls } from '@react-three/drei'
import inst from "./inst"
import * as Tone from 'tone'

let notes = ["C", "D",'E','G']
let octaves = [2,3]
let allNotes = new Array(notes.length * octaves.length).fill().fill().map((val, i) => {
  return notes[i % notes.length] + octaves[Math.floor(i / notes.length)]
})

let hit = 0;
let lerp = THREE.MathUtils.lerp
let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]

const color = new THREE.Color()
let vec = new THREE.Vector3()
let amt = 50;

let mut = {
  radMult: 1,
  radAdd: 0,
  height: 1,
  part: false,
  offsets: new Array(amt).fill().map(() => 0),
  scales: new Array(amt).fill().map(() => 1),
  ys: new Array(amt).fill().map(() => 1),
  pos0: false,
  pos1: false,
  tp: Math.PI * 2,
  size: 2,
  speed: 5,
  lower: false,
  inverted: false,
  extraSize: 0
}

let createPart = (data, loopEnd) => {
  let hold = 0.1 + (Math.random()*0.2)
  let note = getRand(allNotes)
  let note2 = getRand(allNotes)
  let notef = Tone.Frequency(note).toFrequency()
  let note2f = Tone.Frequency(note2).toFrequency()
  const part = new Tone.Part(((time, val) => {
    hit++
    let m = 20
    if(mut.lowers[hit%mut.lowers.length]){
      mut.extraSize = 0.3
    }
    let s = mut.lowers[hit%mut.lowers.length] ? 1 : 0.75
    // let freq = s + Math.abs(mut.pos0[0] + mut.pos0[1] * m)
    // let freq2 = s + Math.abs(mut.pos1[0] + mut.pos1[1] * m)
    let freq = notef*s
    let freq2 = note2f*s
    let freq3 = freq*2
    let freq4 = freq2*2

    let vel = 0.1 + Math.abs(mut.pos0[0]) * 0.1
    let vel2 = 0.1 + Math.abs(mut.pos1[1]) * 0.1
    for(var i = 0; i < 16; i++){
      mut.scales[Math.floor(mut.scales.length*Math.random())] = 8;
    }
    inst.synthL.triggerAttackRelease(freq, val.dur*hold, time, vel);
    inst.synthR.triggerAttackRelease(freq2, val.dur*hold, time, vel2);
    inst.synth3.triggerAttackRelease(freq3, val.dur*hold, time,vel2);
    inst.synth3.triggerAttackRelease(freq4, val.dur*hold, time,vel2);
    if(Math.random()> 0.9){
      mut.moving = true;
      setTimeout(() => {
        mut.moving = false;
      },1000)
    }
  }), data);

  part.loop = true;
  part.loopStart = 0;
  part.loopEnd = loopEnd;
  return part
}

export default function App() {
  function click() {
    mut.radMult = Math.PI
    mut.height = 0.4 + (Math.random()*0.7)
    mut.size = 1.5 + Math.random()
    mut.speed = 1 + (Math.random() * 10)
    mut.tp = getRand([Math.PI * 2, Math.PI * 3]) * (mut.tp < 0 ? 1 : -1)

    Tone.context.resume();
    Tone.Transport.start();


    let dTime2 = 0.2 * Math.floor((Math.random() * 5))
    let rTime2 = 0.5 + Math.random() * 0.5
    inst.delay3.delayTime.linearRampToValueAtTime(0.1 + dTime2, rTime2)
    inst.delay3.wet.linearRampToValueAtTime(0.1 + (0.1 * Math.floor((Math.random() * 2))), rTime2)

    let time = 0;
    let dur = 0
    let durMult = getRand([1])
    let durs = [0.2,0.1,0.3]
    mut.lowers = new Array(Math.floor(getRand([24])/durMult)).fill().map(() => {
      if(Math.random()>0.9){
        mut.lower = !mut.lower
      }
      return mut.lower
    })

    let data = Array.from({ length: getRand([4,6,8]) }, (v, i) => {
      dur = getRand(durs) * durMult;
      let velocity = 0.4 + (Math.random() * 0.2)*dur*0.5
      let scale = 1
      let ret = { time, i, dur, velocity, scale, currScale: 1, durMult }
      time += dur
      return ret
    });
    let loopEnd = time
    if (mut.part) {
      mut.part.stop();
    }
    mut.part = createPart(data, loopEnd)
    mut.part.start();
  }
let isMobile = window.innerWidth < 500

  return (
    <div className="fullscreen" onMouseDown={click}>
      <Canvas dpr={[1, 2]} camera={{ position: [0, 10, isMobile ? 28 : 20], fov: 45 }} >
        <color attach="background" args={['#000']} />
        <ambientLight intensity={0.5} />
        <directionalLight intensity={0.3} position={[5, 25, 20]} />
        <Orbs amt={amt} spinners={40} />
        <OrbitControls autoRotate autoRotateSpeed={0.75} />
      </Canvas>
    </div >

  )
}
let getPos = (t, offset, t2) => {
  const tx = (t * 3 - 1.75) * t;
  const ty = Math.sin(t + (2 * Math.PI * -t * (mut.radMult + mut.radAdd)) * mut.speed) * mut.height;
  const tz = 0;
  vec.set(tx, ty, tz).multiplyScalar((mut.size + mut.extraSize) * t*1.5)
  return [vec.x, vec.y, vec.z]
}

function Orbs({ amt, spinners }) {
  const ref = useRef();
  let geo1 = new THREE.SphereBufferGeometry(0.4)
  let mat1 = new THREE.MeshStandardMaterial({
    color: 0xffffff,
  })
  useFrame((state) => {
    ref.current.children.map((child, i) => child.rotation.set(
      0,
      lerp(child.rotation.y, (i / spinners) * mut.tp, 0.1),
      0))
      mut.extraSize = lerp(mut.extraSize,0,0.8)
  })
  return (
    <>
      <Instances ref={ref} limit={amt * spinners} material={mat1} geometry={geo1}>
        {new Array(spinners).fill().map((_, j) => (
          <group key={j}>
            {new Array(amt).fill().map((props, i) => (
              <Shoe i={i} amt={amt} key={i} {...props} />
            ))}
          </group>
        ))}
      </Instances>
    </>
  )
}

function Shoe({ random, i, amt, ...props }) {
  const ref = useRef()
  const group = useRef()
  useFrame((state) => {
    const t2 = state.clock.getElapsedTime() * Math.PI
    // ref.current.rotation.set(Math.cos(t / 4) / 2, Math.sin(t / 4) / 2, Math.cos(t / 1.5) / 2)
    let t = i / amt
    mut.offsets[i] += 0.001
    let pos = getPos(t, mut.offsets[i], t2)
    if (i === amt - 1) {
      mut.pos1 = pos
    }
    if (!i) {
      mut.pos0 = pos
    }
    let speed = 0.05
    mut.scales[i] = lerp(mut.scales[i], 1, 0.01)
    ref.current.scale.setScalar(0.02 + (Math.abs(ref.current.position.y) * 0.015) * mut.scales[i])
    ref.current.position.set(
      lerp(ref.current.position.x, pos[0], speed),
      lerp(ref.current.position.y, pos[1], speed),
      lerp(ref.current.position.z, pos[2], speed),
    );
  })
  return (
    <group ref={group}>
      <Instance ref={ref} />
    </group>
  )
}

console.log('%c🌱🌱 @ramioso 2021-10-26 🌱🌱 ', 'color: orange');